/**
 * PublicUIContext — signals to shared configurator components that
 * they should render their marketing-native UI variant.
 *
 * When absent (i.e. inside the authenticated admin/customer app), the
 * components fall back to their legacy inline JSX so nothing changes
 * visually for internal users.
 *
 * When present (i.e. inside /l/:slug or /campaigns/:slug), the
 * components render the shared UI from @owntune/ui — which consumes
 * @owntune/theme tokens directly and therefore matches the marketing
 * site 1:1.
 */
import { createContext, useContext } from 'react';

const PublicUIContext = createContext({ active: false });

export function PublicUIProvider({ children, active = true }) {
    return (
        <PublicUIContext.Provider value={{ active }}>
            {children}
        </PublicUIContext.Provider>
    );
}

export function usePublicUI() {
    return useContext(PublicUIContext);
}
